module.exports = __webpack_public_path__ + "img/seating-cabaret.e05c54a0.svg";